const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1477 554c1.11 0 2 .895 2 2s-.89 2-2 2c-1.11 0-2-.895-2-2s.89-2 2-2ZM1485 554c1.11 0 2 .895 2 2s-.89 2-2 2c-1.11 0-2-.895-2-2s.89-2 2-2ZM1493 554c1.11 0 2 .895 2 2s-.89 2-2 2c-1.11 0-2-.895-2-2s.89-2 2-2Z",
    style: {
      fill: "#616d79"
    },
    transform: "translate(-1469 -540)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1477 554c1.11 0 2 .895 2 2s-.89 2-2 2c-1.11 0-2-.895-2-2s.89-2 2-2ZM1485 554c1.11 0 2 .895 2 2s-.89 2-2 2c-1.11 0-2-.895-2-2s.89-2 2-2ZM1493 554c1.11 0 2 .895 2 2s-.89 2-2 2c-1.11 0-2-.895-2-2s.89-2 2-2Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-1469 -508)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownMenu);
export default __webpack_public_path__ + "static/media/dropdown-menu.7673d4ae5df62ca9e780411c40c56110.svg";
export { ForwardRef as ReactComponent };